import apiClient from './apiClient';

const demoService = {
  feedDemoData: async () => {
    const response = await apiClient.post('/demo/feed');
    return response.data;
  },

  deleteDemoData: async () => {
    const response = await apiClient.delete('/demo/delete');
    return response.data;
  }
};

export default demoService;
